import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TesteService } from 'src/app/services/teste.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-acesso',
  templateUrl: './acesso.component.html',
  styleUrls: ['./acesso.component.scss']
})

export class AcessoComponent implements OnInit {

  form: FormGroup;


  constructor( private fb: FormBuilder, private router: Router, private testeService: TesteService) {

  }

  ngOnInit(): void {

  this.initForm();
  

}

validaAcesso(){

  if (this.form.get('cpf').value=='71743537700' || this.form.get('cpf').value=='10204392705' || this.form.get('cpf').value=='33688281772' || this.form.get('cpf').value=='03928305409' || this.form.get('cpf').value=='12502981727'){
    this.router.navigate(['/menu']);
  }else{
    window.prompt('AVISO','Acesso Negado !');
  }
  
  }
  
  voltaAcesso(){


      this.router.navigate(['/']);

    
    }

validaCpf(){

}

initForm() {
  this.form = this.fb.group({
    cpf: '',
    email: ''


  });
}


}

